exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-source-forms-questions-quick-look-styles__quickLook {\n  margin-top: 22px;\n  display: inline-flex;\n  align-items: center;\n  line-height: 1.5;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.src-source-forms-questions-quick-look-styles__maxWidth {\n  max-width: 670px;\n}\n", ""]);

// exports
exports.locals = {
	"quickLook": "src-source-forms-questions-quick-look-styles__quickLook",
	"maxWidth": "src-source-forms-questions-quick-look-styles__maxWidth"
};